import { setTheme } from "theme/default/setTheme";

export const color_rgba_183_200_220_80 = setTheme(({ theme }) => theme.colors.color_rgba_183_200_220_80);
